import { Quote } from "@/config/app-constant";
import { Organiser } from "@/types/Organiser";

import {
  isAvailableNationalityField,
  hidePersonalDetailsFields,
} from "./organiser.utils";

/**
 * Validates organiser fields and returns the redirect path if validation fails
 *
 * @param organiser - The organiser object to validate
 * @param currentPath - The current pathname
 * @param organiserPath - Translated path for organiser page (e.g., "organiser" or "organizador")
 * @param contactDetailsPath - Translated path for contact details page (e.g., "contact-details" or "detalles-contacto")
 * @returns Redirect path if validation fails, null otherwise
 */
export const checkOrganiserFields = (
  organiser: Organiser,
  currentPath: string,
  organiserPath: string,
  contactDetailsPath: string,
  experiment?: {
    deferOrganiserDetailsFlow?: string | null;
  } | null
): string | null => {
  // Check if user is in Spain  A/B test variant
  const isPersonalDetailsDisabled = hidePersonalDetailsFields(experiment);

  const organiserDetails: (keyof Organiser)[] = [
    "title",
    "firstName",
    "lastName",
    "dateOfBirth",
    "country",
    // Skip address field validation if in Spain  A/B test variant
    ...(!isPersonalDetailsDisabled
      ? (["firstLineOfAddress", "city"] as (keyof Organiser)[])
      : []),
    ...(isAvailableNationalityField
      ? (["nationalityId"] as (keyof Organiser)[])
      : []),
  ];

  const hasMissingFields = organiserDetails.some(
    (detail) =>
      !(detail in organiser) ||
      organiser[detail] == null ||
      organiser[detail] === undefined
  );

  if (hasMissingFields) {
    return `/${organiserPath}`;
  }
  if (!organiser.telephone && currentPath.includes(Quote)) {
    return `/${contactDetailsPath}`;
  }

  return null; // No missing fields
};
